module.exports = __webpack_public_path__ + "static/media/story.6d1bb020.png";